<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 277.92 225.3" style="enable-background:new 0 0 277.92 225.3;" xml:space="preserve">
        <g>
            <path :style="defineStroke" class="st0" d="M94.01,172.16c-1.89,0.13-3.79,0.19-5.71,0.19c-45.93,0-83.16-37.23-83.16-83.16S42.37,6.03,88.3,6.03
                s83.16,37.23,83.16,83.16c0,28.25-14.08,53.21-35.61,68.24"/>
            <path :style="defineStroke" class="st1" d="M95.2,156.29c-2.27,0.23-4.57,0.35-6.9,0.35c-37.25,0-67.45-30.2-67.45-67.45s30.2-67.45,67.45-67.45
                s67.45,30.2,67.45,67.45c0,23.92-12.45,44.93-31.23,56.91"/>
            <polyline :style="defineStroke" class="st2" points="88.3,52.01 88.3,89.19 123.23,124.11 	"/>
            <polyline :style="defineStroke" class="st0" points="124.98,13.98 269.3,13.98 269.3,40.74 155.76,40.74 	"/>
            <polyline :style="defineStroke" class="st0" points="188.55,167.49 269.3,167.49 269.3,40.74 	"/>
            <rect x="218.46" y="66.44" :style="defineStroke" class="st1" width="28.96" height="28.96"/>
            <polyline :style="defineStroke" class="st1" points="218.46,123.69 218.46,113.36 247.42,113.36 247.42,142.32 218.46,142.32 218.46,137.08 	"/>
            <rect x="172.63" y="66.44" :style="defineStroke" class="st1" width="28.96" height="28.96"/>
        </g>
        <g>
            <polygon :style="defineStroke" class="st0" points="138.7,216.84 86.83,164.97 115.12,136.69 138.7,160.27 196.87,102.1 225.16,130.39 	"/>
        </g>
    </svg>
</template>
<script>
export default {
    data(){
        return{
            colors:{}
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    computed:{
        defineStroke(){
            return { 'stroke' : this.colors.secondary  }
        }
    }
}
</script>

<style lang="scss" scoped>
    .st0{fill:none;stroke-width:7;stroke-miterlimit:10;}
    .st1{fill:none;stroke-width:6;stroke-miterlimit:10;}
    .st2{fill:none;stroke-width:10;stroke-miterlimit:10;}
</style>